/**
 * google测试环境无法使用
 * @author
 */
import config from '../config';
import CheckRegister from '../thirdparty/check';
import Register from '../thirdparty/register';
import UserLogin from '../../profile/login';

const _system = Uplib.native.getSystem();
const prefix = _system == 'pc' ? 'pcuplive' : 'uplive';

const cache = UpSDK.cache;

const bindType = 15;

let GoogleAuth;

function updateSigninStatus(isSignedIn) {
    // When signin status changes, this function is called.
    // If the signin status is changed to signedIn, we make an API call.
    console.warn('isSignedIn', isSignedIn);
    if (isSignedIn) {
        // 登录成功
        var GoogleUser = GoogleAuth.currentUser.get();
        var { access_token } = GoogleUser.getAuthResponse()
        var profileData = GoogleUser.getBasicProfile();

        console.warn('profileData', profileData);

        $.channel.emit('glOauthSuccess', {
            access_token: access_token,
            profileData: profileData
        });
    } else {
        GoogleAuth.signIn();
    }
}

let google = Object.assign({
    init() {
        Uplib.loading.show({
            text: '正在加载'
        });

        let loadedsdk = false;
        ((d, s, id, cb) => {
            const element = d.getElementsByTagName(s)[0];
            const fjs = element;
            let js = element;
            js = d.createElement(s);
            js.id = id;
            js.src = '//apis.google.com/js/platform.js';
            fjs.parentNode.insertBefore(js, fjs);
            js.onload = cb;
        })(document, 'script', 'google-login', () => {
            let loadedsdk = true;
            this.loadSdkTimer && clearTimeout(this.loadSdkTimer);
            console.warn('google sdk loaded');
            try {
                gapi.load('auth2', () => {
                    let client_id = config.upInfoInPlatform['google'].clientId;

                    gapi.auth2.init({
                        client_id ,
                        scope: 'profile email'
                    }).then(() => {
                        console.warn('google sdk init');
                        GoogleAuth = gapi.auth2.getAuthInstance();

                        GoogleAuth.isSignedIn.listen(updateSigninStatus);

                        // Handle the initial sign-in state.
                        updateSigninStatus(GoogleAuth.isSignedIn.get());
                    });
                })

                $.channel.off('glOauthSuccess');
                $.channel.on('glOauthSuccess', (data) => {
                    this.getGoogleInfo(data);
                });
            } catch (error) {
                Uplib.loading.hide();
                Uplib.notification.simple('Authorization failed');
            }
        });

        this.loadSdkTimer = setTimeout(()=>{
            if (!loadedsdk) {
                Uplib.loading.hide();
                Uplib.notification.simple('Authorization failed');
                new Error("gapi.load Auth2 Timeout")
            }
        }, 3 * 1000)
    },

    getGoogleInfo(data) {
        let isRegistered = this.checkRegistered(data);

        isRegistered.done((registered) => {
            if (registered) {
                // 三方账号已绑定Up直播
                this.getProfileForRegister(data);
            } else {
                // 未绑定
                this.getProfileForNoRegister(data);
            }
        });

        isRegistered.fail(()=>{
            // alert('dd');
        })
    },

    getProfileForNoRegister(data) {
        let registerPromise = this.register(data);

        registerPromise.done((data) => {

            let loginPromise = this.login(data.uid, data.password);

            loginPromise.done((data) => {
                console.log('用户信息', data);

                // 授权成功，真实用户
                cache.setCache('isRegisterRealUser', true);

                Uplib.loading.hide();

                $.channel.emit('authSuccess', data);
            });

            loginPromise.fail((dataWrap)=>{
                Uplib.loading.hide();

                if (dataWrap.code == 4119) {
                    Uplib.notification.simple('device forbidden');
                }
            })
        });

        registerPromise.fail((dataWrap)=>{
            Uplib.loading.hide();

            if (dataWrap.code == 4119) {
                Uplib.notification.simple('device forbidden');
            }

        })
    },

    getProfileForRegister(data) {
        let registerPromise = this.register(data);

        registerPromise.done((data) => {
            console.log('用户信息', data);
            // 授权成功，真实用户
            cache.setCache('isRegisterRealUser', true);

            Uplib.loading.hide();

            $.channel.emit('authSuccess', data);
        });

        registerPromise.fail((dataWrap)=>{
            Uplib.loading.hide();

            if (dataWrap.code == 4119) {
                Uplib.notification.simple('device forbidden');
            }
        })
    },
    /*
     * 第三方账号是否已经绑定过UP直播
     */
    checkRegistered(data) {
        let promise = new CheckRegister({
            bindType: bindType,
            thirdId: data.profileData.getId(),
            thirdToken: data.access_token
        }).promise;

        return promise;
    },

    register(data) {
        let { profileData, access_token } = data;
        let promise = new Register({
            bindType: bindType,
            thirdId: profileData.getId(),
            thirdToken: access_token,
            avatar: profileData.getImageUrl(),
            username: profileData.getName()
        }).promise;

        return promise;
    },

    login(uid, password) {
        let promise = new UserLogin({
            loginType: 1,
            bindType: bindType,
            uid: uid,
            password: password,
        }).promise;

        return promise;
    }

}, Uplib.Events);

export default google;



// WEBPACK FOOTER //
// ./src/js/openjs/deps/login/sns/google.js